import React, { useContext } from 'react';
import { OrderReviewContext } from './OrderReviewContext';
import OrderInfoFormDefinition from './OrderInfoFormDefinition';

function OrderInfoFormDefinitions() {
  const { state } = useContext(OrderReviewContext);

  // console.log(state.orderInfoFormDefinitions)
  return (
    state.orderInfoFormDefinitions &&
    state.orderInfoFormDefinitions.map(fd => <OrderInfoFormDefinition key={fd.formDefinitionId} formDefinition={fd} />)
  );
}

export default OrderInfoFormDefinitions;
